__turbopack_context__.v({
  "active": "MaterialTabs-module-scss-module__WzzMia__active",
  "heading": "MaterialTabs-module-scss-module__WzzMia__heading",
  "separator": "MaterialTabs-module-scss-module__WzzMia__separator",
  "tab": "MaterialTabs-module-scss-module__WzzMia__tab",
  "tabList": "MaterialTabs-module-scss-module__WzzMia__tabList",
  "tabs": "MaterialTabs-module-scss-module__WzzMia__tabs",
});
